import script from "./ContactTrendCharts.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactTrendCharts.vue?vue&type=script&lang=ts&setup=true"

import "./ContactTrendCharts.vue?vue&type=style&index=0&id=0ffd84fc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffd84fc"]])

export default __exports__